import { Record as record, List } from 'immutable';
import _ from 'lodash';

import { PaymentType } from '../../constants/AppConstants';

const defaults = {
    orderId: null,
    email: null,
    phone: null,
    vouchers: new List(),
    card: null,
    cardToken: null,
    cardAmount: 0,
    storedCard: null,
    cv2: null,
    paypalNonce: null,
    paypalDevice: null,
    applePayNonce: null,
    applePayDeviceData: null,
    googlePayNonce: null,
    googlePayDeviceData: null,
};


class AuthRequest extends record(defaults) {

    static fromJSON (json = {}) {
        return new AuthRequest({json, vouchers: new List(json.vouchers)});
    }

    justVouchers () {
        return this.vouchers.size && !this.card && !this.storedCard && !this.paypalNonce;
    }

    serialize () {
        return {
            orderId: this.orderId,
            payments: _.compact([
                this._serializeCard(),
                this._serializeStoredCard(),
                this._serializePaypal(),
                this._serializeApplePay(),
                this._serializeGooglePay(),
            ])
        };
    }

    serializeCocs (isAmend = false) {
        const vouchers = this.vouchers.toJS().reduce(
            (dict, { id, amount }) => {
                dict[id] = { amount };
                return dict;
            }, {});

        let storedCards = this.storedCard && {
            [this.storedCard]: {
                amount: this.cardAmount,
                cv2: this.cv2
            }
        };

        if (!storedCards && isAmend) {
            storedCards = {};
        }

        return {
            email: this.email,
            phone: this.phone,
            cards: _.compact([ this._serializeCard() ]),
            storedCards: storedCards,
            vouchers,
            // Visa Checkout is removed, but COCS still receives this field; drop it with the backend endpoints
            visaCards: []
        };
    }

    _serializeVoucher (voucher, id) {
        return {
            id: `voucher-${id}`,
            type: PaymentType.VOUCHER,
            url: voucher.id,
            amount: voucher.amount
        };
    }

    _serializeCard () {
        const { card, email, phone } = this;
        const result = this.cardToken && {
            id: 'card',
            type: PaymentType.CARD,
            amount: this.cardAmount,
            token: this.cardToken,
            cardHolderName: card.cardHolderName,
            expiryDate: card.expiryMonth + '/' + card.expiryYear,
            email: email,
            phone: phone,
            address: {
                line1: card.addressLine1,
                line2: card.addressLine2,
                line3: card.addressLine3,
                town: card.townCity,
                postCode: card.postcode,
                country: card.country
            },
            store: !!card.store,
            nickname: card.store ? card.nickname : null
        };

        return result;
    }

    _serializeStoredCard () {
        return this.storedCard && {
            id: 'stored-card',
            type: PaymentType.STORED_CARD,
            amount: this.cardAmount,
            url: this.storedCard,
            cv2: this.cv2
        };
    }

    _serializePaypal () {
        return this.paypalNonce && {
            id: 'paypal',
            type: PaymentType.PAYPAL,
            amount: this.cardAmount,
            nonce: this.paypalNonce,
            deviceData: this.paypalDevice
        };
    }

    _serializeApplePay () {
        return this.applePayNonce && {
            id: 'apple-pay',
            type: PaymentType.APPLE_PAY,
            amount: this.cardAmount,
            nonce: this.applePayNonce,
            deviceData: this.applePayDeviceData
        };
    }

    _serializeGooglePay () {
        return this.googlePayNonce && {
            id: 'google-pay',
            type: PaymentType.GOOGLE_PAY,
            amount: this.cardAmount,
            nonce: this.googlePayNonce,
            deviceData: this.googlePayDeviceData
        };
    }
}


export default AuthRequest;
